// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_AdditionalServiceFiscalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/additional_service_fiscal/get/{additional_service_id}
 *
 * `fiscal` is null when neither a franchise-specific nor a global fiscal
 * row exists for the additional service at all.
 */
import type { So_AdditionalServiceFiscalEffectiveRow } from './So_AdditionalServiceFiscalEffectiveRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_AdditionalServiceFiscalResponseDados = So_AdditionalServiceFiscalEffectiveRow;

export type So_AdditionalServiceFiscalResponse = ApiResponse<So_AdditionalServiceFiscalResponseDados>;

registerResponseContract('So_AdditionalServiceFiscalResponse', {
  _nullable:                                               { type: 'boolean', required: false },
  so_additional_service_id:                                { type: 'number',  required: true },
  franchise_id:                                            { type: 'number',  required: false },
  is_override:                                             { type: 'boolean', required: true },
  is_configured:                                           { type: 'boolean', required: true },
  so_additional_service_fiscal_lc116_code:                 { type: 'string',  required: false },
  so_additional_service_fiscal_municipal_service_code:     { type: 'string',  required: false },
  so_additional_service_fiscal_iss_aliquota:               { type: 'number',  required: false },
  so_additional_service_fiscal_iss_retido_default:         { type: 'number',  required: false },
  so_additional_service_fiscal_municipio_incidencia_ibge:  { type: 'string',  required: false },
  so_additional_service_fiscal_cnae:                       { type: 'string',  required: false },
  so_additional_service_fiscal_codigo_tributacao_nacional: { type: 'string',  required: false },
})
